/**
 * Estados de los lotes
 */
export const LotSaleStatus = Object.freeze([
  { name: 'Inactivo', value: 0 },
  { name: 'Activo', value: 1 },
  { name: 'Cancelado', value: 2 },
]);

const ReservationTypes = Object.freeze([
  { name: 'Inicial', value: 0 },
  { name: 'Parcial', value: 1 },
  { name: 'Total', value: 2 },
]);

/**
 * Financiamiento
 */
const FinancingPlanStatus = Object.freeze([
  { name: 'Inactivo', value: 0 },
  { name: 'Activo', value: 1 },
  { name: 'Pagado', value: 2 },
  { name: 'Refinanciado', value: 3 },
  { name: 'Cancelado', value: 4 },
]);

const DiscountTypes = Object.freeze([
  { name: 'Ninguno', value: 0 },
  { name: 'Porcentaje', value: 1 },
  { name: 'Fijo', value: 2 },
]);

const InstallmentStatus = Object.freeze([
  { name: 'Inactivo', value: 0 },
  { name: 'Activo', value: 1 },
  { name: 'Pagado', value: 2 },
]);

const FinancingPeriodTypes = Object.freeze([
  { name: 'Mensual', value: 0 },
  { name: 'Anual', value: 1 },
]);

const SaleTypes = Object.freeze([
  { name: 'Contado', value: 0 },
  { name: 'Crédito', value: 1 },
  { name: 'Financiado', value: 2 },
]);

export default {
  // Financiamiento
  DiscountTypes,
  InstallmentStatus,
  FinancingPeriodTypes,
  FinancingPlanStatus,
  SaleTypes,
  // Estados de lotes
  LotSaleStatus,
  ReservationTypes,
};
